import React, {useRef, useState} from "react";
import {Navigate} from 'react-router-dom';
import Box from "@mui/material/Box";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Button, Card, Divider, Grid, IconButton, InputAdornment, Stack, Typography} from '@mui/material';
import InputField from "../../components/InputField";
import Form from "../../components/Form";
import {BASE_URL} from "../../constants";
import AlertBar from "../../components/AlertBar";
import {reportErrors} from "../../helpers";

export default function Verification(props) {
    const form = useRef();
    const alert = useRef();
    const passwordRef = useRef();
    const confirmPasswordRef = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [isCreated, setIsCreated] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const submit = () => {
        let data = {password};
        if (!isSubmitting && password === confirmPassword && form.current.validate()) {
            setIsSubmitting(true);
            alert.current.showProgress("")
            window.axios
                .post(`${BASE_URL}api/verification`, data)
                .then((response) => {
                    setIsSubmitting(false);
                    alert.current.hide();
                    alert.current.showSuccess("Password Changed Successfully")
                    setTimeout(() => {
                        setIsCreated(true);
                    }, 2000);
                }).catch((error) => {
                setIsSubmitting(false);
                reportErrors(alert.current, error);
            });
        }

    }

    return (
        isCreated ? <Navigate to={{pathname: "/"}}/> :
            <Box sx={{minHeight: '100vh'}}>
                <Grid item xs={12} container justifyContent="center" alignItems="center"
                      sx={{minHeight: {xs: 'calc(100vh - 134px)', md: 'calc(100vh - 112px)'}}}>
                    <Card
                        elevation={2}
                        sx={{
                            maxWidth: {xs: 400, lg: 475},
                            margin: {xs: 2.5, md: 3},
                            '& > *': {
                                flexGrow: 1,
                                flexBasis: '50%'
                            }
                        }}
                    >
                        <Box sx={{p: {xs: 2, sm: 3, md: 4, xl: 5}}}>
                            <Grid item>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Stack direction="row" justifyContent="space-between" alignItems="baseline"
                                               sx={{mb: {xs: -0.5, sm: 0.5}}}>
                                            <Typography variant="h4">Change Password</Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AlertBar ref={alert}/>
                                        <Form ref={form}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <InputField
                                                        ref={passwordRef}
                                                        required={true}
                                                        type={showPassword ? 'text' : 'password'}
                                                        placeholder="New password"
                                                        onChange={(value) => setPassword(value)}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    edge="end"
                                                                    size="large"
                                                                >
                                                                    {showPassword ? <VisibilityOffIcon/> :
                                                                        <RemoveRedEyeIcon/>}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputField
                                                        ref={confirmPasswordRef}
                                                        required={true}
                                                        type={showConfirmPassword ? 'text' : 'password'}
                                                        placeholder="Confirm password"
                                                        onChange={(value) => setConfirmPassword(value)}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowConfirmPassword}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    edge="end"
                                                                    size="large"
                                                                >
                                                                    {showConfirmPassword ? <VisibilityOffIcon/> :
                                                                        <RemoveRedEyeIcon/>}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Button
                                                        disableElevation
                                                        disabled={isSubmitting}
                                                        fullWidth
                                                        size="large"
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => submit()}
                                                    >
                                                        Submit
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider>
                                                        <Typography variant="caption"> Verification </Typography>
                                                    </Divider>
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Card>
                </Grid>
            </Box>
    );
}